//Roles
import { ADMIN, MODIFICAR_REQ, CONTROL_REQ} from './roles'

//Habilitados para ver solapa nav de productos.
export const VER_PRODUCTOS = [ADMIN, CONTROL_REQ];
//Habilitados para ver todos los requerimientos de la lista y no solo las que fueron creados por el usuario.
export const VER_TODOS_NOTAS_PEDIDO = [ADMIN, CONTROL_REQ];
//Habilitados para modificar el estado de autorización de un requerimiento.
export const MODIFICAR_ESTADO_NOTA_PEDIDO = [ADMIN, CONTROL_REQ];
//Habilitados para editar notas privadas de un requerimiento.
export const EDITAR_NOTAS_PRIVADAS_REQ = [ADMIN, CONTROL_REQ];
//Habilitados para editar notas publicas de un requerimiento.
export const EDITAR_NOTAS_PUBLICAS_REQ = [ADMIN, CONTROL_REQ];
//Habilitados para usar la pantalla de edición de un requerimiento ya creado.
export const EDITAR_REQUERIMIENTO = [ADMIN, MODIFICAR_REQ];
//Habilitados para ver solapa nav de usuario.
export const VER_USUARIOS = [ADMIN];
//Habilitados para ver solapa nav de sector de requerimientos.
export const VER_SECTORES_REQUERIMIENTOS = [ADMIN, CONTROL_REQ];
//Habilitados para ver solapa nav de subcuentas.
export const VER_SUBCUENTAS = [ADMIN, CONTROL_REQ];
//Habilitados para reenviar un requerimiento desde la lista de requerimientos.
export const REENVIO_REQ_SERVIDOR = [ADMIN, CONTROL_REQ];
//Habilitados para reenviar un requerimiento desde la lista de requerimientos.
export const VISUALIZA_ULTIMO_PRECIO_COMPRA = [ADMIN, CONTROL_REQ];


export const VER_GRUPOS = [ADMIN];

//Habilitados para ver configuracion global.
export const VER_CONFIG_GLOBAL = [ADMIN];

//Habilitados para ver reportes.
export const VER_REPORTES = [ADMIN, CONTROL_REQ, MODIFICAR_REQ];

//Habilitados para ver solapa nav de depósitos.
export const VER_DEPOSITOS = [ADMIN, CONTROL_REQ];
